var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckTrue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 14C3.6325 14 0.5 10.8675 0.5 7C0.5 3.1325 3.6325 0 7.5 0C11.3675 0 14.5 3.1325 14.5 7C14.5 10.8675 11.3675 14 7.5 14ZM10.6675 4.7075C10.4575 4.4975 10.125 4.4975 9.915 4.7075L6.5725 8.1375L5.085 6.5975C4.875 6.3875 4.5425 6.3875 4.3325 6.5975C4.1225 6.8075 4.1225 7.1575 4.3325 7.3675L6.205 9.2925C6.415 9.5025 6.7475 9.5025 6.9575 9.2925L10.685 5.4775C10.8775 5.2675 10.8775 4.9175 10.6675 4.7075Z",
    fill: "#008B3A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckTrue);
export default __webpack_public_path__ + "static/media/check-true.db06d8ace60b43c69c6a22a4d9e1cab2.svg";
export { ForwardRef as ReactComponent };